import type { SorterResult } from "antd/es/table/interface";
import { ISortObj } from "../../../../Models/applicationModels";
import { AgentsTblKeys } from "../../agents.constants";

export const AGENTS_COLUMN_TO_SORT_API_FIELD: Partial<Record<AgentsTblKeys, string>> = {
    [AgentsTblKeys.EMAIL]: "userEmail",
    [AgentsTblKeys.CELL_NUMBER]: "userPhoneNo",
    [AgentsTblKeys.BUSINESS_NAME]: "agencyName",
};

export const getAgentsSortApiField = (column: AgentsTblKeys): string =>
    AGENTS_COLUMN_TO_SORT_API_FIELD[column] ?? column;

export const AGENTS_SORTABLE_KEYS = new Set<AgentsTblKeys>([
    AgentsTblKeys.CREATED_ON,
    AgentsTblKeys.NAME,
    AgentsTblKeys.EMAIL,
    AgentsTblKeys.CELL_NUMBER,
    AgentsTblKeys.USER_TYPE,
    AgentsTblKeys.BUSINESS_NAME,
    AgentsTblKeys.WRITING_NUMBER,
    AgentsTblKeys.AGENCY_NUMBER,
    AgentsTblKeys.LAST_LOGIN_ON,
]);

export const handleAgentsTableSortChange = (
    sorter: SorterResult<unknown> | SorterResult<unknown>[],
    onSortChange: (sortItem: ISortObj | null) => void
) => {
    const activeSorter = Array.isArray(sorter) ? sorter[0] : sorter;
    const sortOrder = activeSorter?.order;
    const sortField = activeSorter?.field ?? activeSorter?.columnKey;

    if (!sortOrder || !sortField) {
        onSortChange(null);
        return;
    }

    onSortChange({
        value: getAgentsSortApiField(String(sortField) as AgentsTblKeys),
        sortDescending: sortOrder === "descend",
    });
};

export const getAgentsColumnSortOrder = (
    key: AgentsTblKeys,
    sortRequest: ISortObj | null
): "ascend" | "descend" | null => {
    if (!sortRequest || sortRequest.value !== getAgentsSortApiField(key)) return null;
    return sortRequest.sortDescending ? "descend" : "ascend";
};
